module.exports = __webpack_public_path__ + "static/img/SJSS1.80c5996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/SJSS1.png
// module id = 1Rxa
// module chunks = 0